var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 30 30",
    height: "45px",
    id: "Layer_1",
    viewBox: "0 0 30 30",
    width: "45px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.071,0l2.4,26.963L15.233,30l10.839-3.037L28.471,0H2.071z M21.065,21.121l-7.537,3.129l-6.543-3.129l0.666-4.17h2.783   l-0.271,1.723l3.957,1.885l4.555-1.885l0.639-3.975H7.987l0.545-3.48h11.334l0.355-2.238H8.897L9.45,5.5h14.108L21.065,21.121z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.c548a22bcf7a92dd0c9c7fcd4526cdd9.svg";
export { ForwardRef as ReactComponent };